import { publicClient, privateClient } from './client';
import { PaymentInstruction } from './PaymentInstruction';

const transactionsPaymentInstruction = (pub: boolean) => new PaymentInstruction(pub ? publicClient : privateClient);
export default transactionsPaymentInstruction;
